(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("StringToReact", ["react"], factory);
	else if(typeof exports === 'object')
		exports["StringToReact"] = factory(require("react"));
	else
		root["StringToReact"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return 